// Kleine popover voor weergave-voorkeuren — geen scenario-data, geen
// admin-instellingen. Voorkeuren leven in de Zustand-store en worden via
// localStorage gepersist (zie state/store.ts).
//
// Open/sluit-patroon volgt ScenarioMenu: parent houdt `open` vast, klikken
// buiten of Esc sluit.

import { useEffect, useRef } from "react";
import { useStore } from "../state/store";

interface Props {
  open: boolean;
  onClose: () => void;
}

export function ViewSettingsPopover({ open, onClose }: Props) {
  const ref = useRef<HTMLDivElement | null>(null);
  const shadowOpacity = useStore((s) => s.shadowOpacity);
  const setShadowOpacity = useStore((s) => s.setShadowOpacity);

  useEffect(() => {
    if (!open) return;
    function onDocClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    }
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    // Eén tick wachten anders sluit dezelfde klik die de popover opende 'm meteen weer.
    setTimeout(() => document.addEventListener("mousedown", onDocClick), 0);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      ref={ref}
      className="absolute right-0 top-full mt-1 z-40 w-72 bg-card border border-border rounded-lg shadow-xl p-3"
    >
      <h3 className="text-sm font-semibold mb-2">Weergave</h3>

      <label
        htmlFor="shadow-opacity"
        className="text-xs text-muted-foreground flex items-center justify-between"
      >
        <span>Schaduwzichtbaarheid</span>
        <span className="tabular-nums">{shadowOpacity}%</span>
      </label>
      <input
        id="shadow-opacity"
        type="range"
        min={10}
        max={100}
        step={1}
        value={shadowOpacity}
        onChange={(e) => setShadowOpacity(Number.parseInt(e.target.value, 10))}
        className="w-full mt-1"
      />
      <p className="text-[11px] text-muted-foreground mt-1 leading-snug">
        Hoeveel donkerder de schaduw op de 2D-kaart wordt getekend. Wordt nog
        verrekend met de doorlatendheid van het schaduwwerpende blok (bv. een
        boombladdek werpt lichter).
      </p>
    </div>
  );
}
